import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/app/ProtectedRoute";
import ErrorBoundary from "@/components/app/ErrorBoundary";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Scan from "@/pages/Scan";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Admin from "@/pages/Admin";
import AdminAudit from "@/pages/AdminAudit";
import AdminStats from "@/pages/AdminStats";
import AdminReview from "@/pages/AdminReview";
import AdminSettings from "@/pages/AdminSettings";
import VpReview from "@/pages/VpReview";
import AcceptInvite from "@/pages/AcceptInvite";
import AdminEmailDiagnostic from "@/pages/AdminEmailDiagnostic";
import Reports from "@/pages/Reports";
import Stats from "@/pages/Stats";
import Shares from "@/pages/Shares";
import PublicShare from "@/pages/PublicShare";

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/s/:token" element={<PublicShare />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
      <Route path="/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
      <Route path="/shares" element={<ProtectedRoute><Shares /></ProtectedRoute>} />
      <Route path="/scan" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
      <Route path="/invoice/:id" element={<ProtectedRoute><InvoiceDetail /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
      <Route path="/admin/review" element={<ProtectedRoute requireAdmin><AdminReview /></ProtectedRoute>} />
      <Route path="/admin/audit" element={<ProtectedRoute requireAdmin><AdminAudit /></ProtectedRoute>} />
      <Route path="/admin/stats" element={<ProtectedRoute requireAdmin><AdminStats /></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute requireAdmin><AdminSettings /></ProtectedRoute>} />
      <Route path="/admin/email-diagnostic" element={<ProtectedRoute requireAdmin><AdminEmailDiagnostic /></ProtectedRoute>} />
      <Route path="/vp/review" element={<ProtectedRoute requireVp><VpReview /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <ThemeProvider>
            <AuthProvider>
              <AppRouter />
            </AuthProvider>
          </ThemeProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
